export const yellowQuote = 'https://acko-cms.ackoassets.com/yellow_quote_563b028556.svg'
export const orangeQuote = 'https://acko-cms.ackoassets.com/orange_quote_e8e2c0dc94.svg'
